module.exports = __webpack_public_path__ + "static/img/slide-next.85d3efc3.svg";